/**
 * Control Levels (FSD 2.2.5 FIN-F06 V06): the per-cost-centre budget control level and
 * tolerance, with the legal entity default they inherit. Replaces the retired
 * `/budget/policy` screen; the redirect lives in `router/legacyRedirects.ts`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_CONTROL_LEVEL_PERMISSIONS } from '@/modules/budget/control-levels/permissions'

export const BUDGET_CONTROL_LEVEL_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/control-levels',
    name: 'budget-control-levels',
    component: () => import('@/modules/budget/control-levels/ControlLevelsView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetControlLevels',
      permission: BUDGET_CONTROL_LEVEL_PERMISSIONS.read,
    },
  },
]

export function controlLevelsRoute(companyId?: number | null): string {
  return companyId === undefined || companyId === null
    ? '/budget/control-levels'
    : `/budget/control-levels?companyId=${companyId}`
}
